import { render, staticRenderFns } from "./m-social-links.vue?vue&type=template&id=c2b6c4be"
import script from "./m-social-links.vue?vue&type=script&lang=js"
export * from "./m-social-links.vue?vue&type=script&lang=js"
import style0 from "./m-social-links.vue?vue&type=style&index=0&id=c2b6c4be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports